import { render, staticRenderFns } from "./semaltForm.vue?vue&type=template&id=48115300&scoped=true&"
import script from "./semaltForm.vue?vue&type=script&lang=js&"
export * from "./semaltForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48115300",
  null
  
)

export default component.exports